import * as tslib_1 from "tslib";
import { observer } from 'mobx-react';
import * as React from 'react';
import { AdsPanel } from 'owa-mail-ads';
import { areDisplayAdsEnabled } from 'owa-mail-ads-shared';
var styles = require('./AdsPanelStub.scss');
var AdsPanelStub = /** @class */ (function (_super) {
    tslib_1.__extends(AdsPanelStub, _super);
    function AdsPanelStub(props) {
        var _this = _super.call(this, props) || this;
        AdsPanelStub_1.adsEnabled = areDisplayAdsEnabled();
        return _this;
    }
    AdsPanelStub_1 = AdsPanelStub;
    AdsPanelStub.prototype.render = function () {
        var _this = this;
        var adContainerClasses = [styles.adsContainer];
        if (!AdsPanelStub_1.adsEnabled || this.props.isHidden) {
            adContainerClasses.push(styles.hide);
        }
        else if (this.props.isBottom) {
            adContainerClasses.push(styles.bottom);
        }
        return (React.createElement("div", { ref: function (ref) { return (_this.adsContainer = ref); }, className: adContainerClasses.join(' ') }, AdsPanelStub_1.adsEnabled && React.createElement(AdsPanel, { isBottom: this.props.isBottom })));
    };
    var AdsPanelStub_1;
    AdsPanelStub = AdsPanelStub_1 = tslib_1.__decorate([
        observer
    ], AdsPanelStub);
    return AdsPanelStub;
}(React.Component));
export default AdsPanelStub;
//# sourceMappingURL=AdsPanelStub.js.map